import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import DynamicTable from "../../components/dynamicTable";
import AppContainer from "../../components/containers/AppContainer";

const jobTableHeader = [
  "JOB NAME",
  "REQUIRED PEOPLES",
  "APPOINTMENT DATE",
  "END DATE",
  "START TIME",
  "END TIME",
  "DURATION (DAYS)",
  "TOTAL HOURS(PER DAY)",
  "HOURLY RATE",
  "TOTAL AMOUNT",
];

const jobDisplayRows = [
  "name",
  "requiredPeoples",
  "startDate",
  "endDate",
  "startTime",
  "endTime",
  "duration",
  "totalHours",
  "hourlyRate",
  "totalAmount",
];

const JobDetailsDialog = ({ open, onClose, jobData }) => {
  if (!jobData) return null;

  const promo = jobData?.appliedPromo || null;

  // Calculate total job amount
  const totalJobAmount = jobData.job?.reduce((acc, job) => {
    console.log(acc, job, "acc, jobacc, jobacc, job");

    const jobTotal =
      parseFloat(job.totalHours) *
      parseFloat(job.hourlyRate) *
      (job.requiredPeoples || 1);
    return acc + jobTotal;
  }, 0);

  // Calculate discount properly
  let discountAmount = 0;
  if (promo) {
    if (promo.discountType === "percentage") {
      discountAmount = (totalJobAmount * parseFloat(promo.discountValue)) / 100;
    } else if (promo.discountType === "flat") {
      discountAmount = parseFloat(promo.discountValue);
    }
  }

  const processedJobData = jobData.job?.map((job) => {
    const startDate = moment(job.startDate);

    const endDate = moment(job.endDate);
    const momentDate1 = moment(endDate);
    const momentDate2 = moment(startDate);
    let duration = momentDate1.diff(momentDate2, "days") + 1;

    const totalAmount =
      parseFloat(job.totalHours) *
      parseFloat(job.hourlyRate) *
      (job.requiredPeoples || 1);

    return {
      ...job,
      startDate: startDate.format("MMMM DD, YYYY"),
      endDate: endDate.format("MMMM DD, YYYY"),
      duration: `${duration} days`,
      totalAmount: totalAmount.toFixed(2),
      hourlyRate: `${job.hourlyRate}`,
      totalHours: `${job.totalHours} hrs`,
    };
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Job Details
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider sx={{ my: 1 }} />

      <DialogContent>
        <AppContainer>
          <Box>
            <DynamicTable
              tableHeader={jobTableHeader}
              displayRows={jobDisplayRows}
              tableData={processedJobData}
              showPagination={false}
            />

            {/* ---------------- PROMO SECTION ---------------- */}
            {promo && (
              <Box
                sx={{
                  mt: 4,
                  p: 3,
                  borderRadius: "14px",
                  background: "white",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  border: "1px solid #e4e4e4",
                }}
              >
                {/* Header */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    p: 1.5,
                    borderRadius: "10px",
                    background: "linear-gradient(90deg, #421108ff, #421108ff)",
                    color: "white",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: "600",
                      color: "#FFFFFF",
                    }}
                  >
                    🎉 Promo Applied
                  </Typography>
                </Box>

                {/* Content */}
                <Box sx={{ pl: 1 }}>
                  <Typography sx={{ mb: 1.2, fontSize: "16px" }}>
                    <strong>Promo Code:</strong> {promo.code}
                  </Typography>

                  <Typography sx={{ mb: 1.2, fontSize: "16px" }}>
                    <strong>Discount Type:</strong>{" "}
                    {promo.discountType === "percentage"
                      ? `${promo.discountValue}% (Percentage)`
                      : `Flat $${promo.discountValue}`}
                  </Typography>

                  <Typography
                    sx={{ mb: 0.5, fontSize: "16px", color: "#2e7d32" }}
                  >
                    <strong>Discount Amount:</strong> $
                    {discountAmount.toFixed(2)}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </AppContainer>
      </DialogContent>
    </Dialog>
  );
};

export default JobDetailsDialog;
